import { useCallback, useEffect, useState } from "react"
import { ILayoutVideosProps } from "../multi-videos"
import UserVideoDisplay from "@fc/videocall/UserVideoDisplay/userVideoDisplay"
import Avatar from "@components/profile/avatar"
import SelectedUserVideoDisplay from "@fc/videocall/UserVideoDisplay/SelectedUserVideoDisplay"

const Spotlight = (props: ILayoutVideosProps) => {
    const {
        users,
        start,
        userList,
        myUsername,
        ownTrack,
        getUsername,
        getCurrentUser
    } = props

    const [selectedUser, setSelectedUser] = useState<string>()
    const [amISelected, setAmISelected] = useState<boolean>(false)

    /**
     * Check if new user who joins the videocall should be automatically selected
     */
    const [userGotIn, setUserGotIn] = useState<boolean>(true)

    useEffect(() => {
        console.log("Users length", users.length)
        if(users.length === 0)
        {
            setSelectedUser(myUsername)
            setAmISelected(true)
            setUserGotIn(true)
        }
        else if(users.length === 1 || (!selectedUser && users.length > 0))
        {
            if(userGotIn)
                setSelectedUser(users[0].uid as string)
            else
                setSelectedUser(selectedUser)
            setAmISelected(selectedUser === myUsername)
            setUserGotIn(false)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedUser, users.length])

    const selectVideo = (username: string) => {
        setAmISelected(username === myUsername)
        setSelectedUser(username)
    }

    /**
     * Retrieves the local video track or the remote selected track 
     * based on the user selection
     */
    const getMainVideoDisplay = useCallback(() => {
        if(!selectedUser) return null
        if(selectedUser === myUsername)
        {
            return (
                <UserVideoDisplay
                    username={getUsername(myUsername)}
                    size={30}
                    track={ownTrack()}
                    key={getUsername(myUsername)}
                    roleCode="PA" />
            )
        }
        else
        {
            const user = getCurrentUser(selectedUser)
            return (
                <UserVideoDisplay
                    user={user}
                    username={selectedUser}
                    size={120}
                    key={selectedUser}
                    roleCode="PA" />
            )
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getCurrentUser, selectedUser, myUsername])

    return (
        <div className="VideoCall__Spotlight">
            <div className="VideoCall__Spotlight-Selected">
                {/* This has to be dynamic */}
                {getMainVideoDisplay()}
            </div>

            <div className="VideoCall__SpotlightList">
                {start && selectedUser && 
                    <>
                        { !amISelected ?
                            <UserVideoDisplay
                                username={getUsername(myUsername)}
                                size={30}
                                track={ownTrack()}
                                key={getUsername(myUsername)}
                                roleCode="PR"
                                onClick={selectVideo}
                                userSelected={selectedUser} />
                            :
                            <div className="VideoCall__VideoLayout-Selected">
                                <Avatar  
                                    username={myUsername}
                                    roleCode="PR"
                                    size={30}
                                    editable={false} />
                            </div>
                        }
                        {
                            userList.map(username => {
                                return (
                                    <SelectedUserVideoDisplay
                                        key={username}
                                        username={username}
                                        selectedUser={selectedUser}
                                        getCurrentUser={getCurrentUser}
                                        selectVideo={selectVideo} />
                                )
                            })
                        }
                    </>
                }
            </div>
        </div>
    )
}

export default Spotlight
